<div class="cx-scope cx-request">
  <div class="cx-request-head">
    <span class="cx-request-icon" aria-hidden="true"><cx-icon name="file-text"></cx-icon></span>
    <div class="cx-request-heading">
      <h2>{{ title }}</h2>
      <p>For {{ request.patient.name }} · from MedicAI Connect</p>
    </div>
    <button type="button" class="cx-btn cx-btn--ghost cx-request-close" (click)="close()" aria-label="Close">
      <cx-icon name="x"></cx-icon>
    </button>
  </div>

  <div class="cx-request-body">
    <div class="cx-request-why" *ngIf="request.details.reason || request.details.claimNumber">
      <p *ngIf="request.details.reason">{{ request.details.reason }}</p>
      <p class="cx-request-meta" *ngIf="request.details.claimNumber">Claim {{ request.details.claimNumber }}</p>
    </div>

    <p class="cx-request-error" role="alert" *ngIf="error">{{ error }}</p>

    <ng-container *ngIf="step === 'view'">
      <p *ngIf="patientHere">CURA can draft the letter from {{ request.patient.name }}'s file. You check and change it before anything is sent.</p>
      <p class="cx-request-warn" *ngIf="!patientHere">This patient is not linked to a patient in your practice, so CURA cannot draft the letter. Link them from the card's patient file, then open the request again.</p>
    </ng-container>

    <ng-container *ngIf="step === 'declining'">
      <label class="cx-request-label" for="cx-decline-reason">Why are you declining?</label>
      <textarea id="cx-decline-reason" class="cx-request-input" rows="3" [(ngModel)]="reason" placeholder="For example: not clinically indicated"></textarea>
    </ng-container>

    <div class="cx-request-wait" *ngIf="step === 'drafting'" role="status">CURA is drafting the letter from the patient's file…</div>

    <ng-container *ngIf="step === 'review'">
      <label class="cx-request-label" for="cx-letter">Check the letter and change anything you need</label>
      <textarea id="cx-letter" class="cx-request-input cx-request-letter" [(ngModel)]="letter"></textarea>
      <p class="cx-request-meta">Accepting puts it on your letterhead, files it on the patient's timeline and sends it to MedicAI Connect.</p>
    </ng-container>

    <div class="cx-request-wait" *ngIf="step === 'sending'" role="status">Sending…</div>
  </div>

  <div class="cx-request-actions">
    <ng-container *ngIf="step === 'view'">
      <button type="button" class="cx-btn cx-btn--outline cx-btn--auto" (click)="step = 'declining'">Decline</button>
      <button type="button" class="cx-btn cx-btn--primary cx-btn--auto" [disabled]="!patientHere" (click)="draft()">Draft with CURA</button>
    </ng-container>
    <ng-container *ngIf="step === 'declining'">
      <button type="button" class="cx-btn cx-btn--ghost cx-btn--auto" (click)="step = 'view'">Back</button>
      <button type="button" class="cx-btn cx-btn--destructive cx-btn--auto" [disabled]="!reason.trim()" (click)="decline()">Decline request</button>
    </ng-container>
    <ng-container *ngIf="step === 'review'">
      <button type="button" class="cx-btn cx-btn--ghost cx-btn--auto" (click)="draft()">Draft again</button>
      <button type="button" class="cx-btn cx-btn--primary cx-btn--auto" [disabled]="!letter.trim()" (click)="accept()">Accept and send</button>
    </ng-container>
  </div>
</div>
